// extracted by mini-css-extract-plugin
export default {"container":"view-quotation-modal_container__vCB8m","actions":"view-quotation-modal_actions__SE87l"};